/**
 * Espelha o request de POST Compra/idCompra/{idCompra}/ocorrencia da API Compras: anotação do usuário no
 * histórico da compra (tipo 5). Tipo, origem e usuário são postos pelo servidor.
 */
export class CriarCompraOcorrenciaRequest {
  /** Texto do usuário, até 1000 caracteres. */
  descricao: string;
  /** Data do fato, sem futuro; ausente = agora. */
  dataOcorrencia: Date | null = null;
}
